import { sylvanus } from '~/services/serviceInstances';

type DeleteDdeModelRequest = {
  modelId: string;
  tableId: string;
};

export const deleteDdeModel = async ({
  modelId,
  tableId,
}: DeleteDdeModelRequest): Promise<void> => {
  await sylvanus.remove(`/dde/table/${tableId}/model/${modelId}`);
};
